import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class SLETDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  
				  <p>SLET is a state-level exam and is conducted by state-controlled bodies. It is administered by the National Testing Agency (NTA) on behalf of the University Grants Commission (UGC) to determine who is eligible to apply for college and university lectureships. Mostly, every state has its own body that conducts this exam. Candidates who aspire to become Assistant professors or Lecturers in State-owned institutions should take up these exams.  
                    </p>
                    <p><b>These exams are conducted once a year. </b></p>
                    </ScrollAnimation>	

					<ScrollAnimation animateIn="fadeInRight"><br/>
						<h5 className="mb-0 mt-2">WHY MIET?</h5><br/>
						<p>Students can benefit from MIET's years of experience and instructors' expertise while preparing for their dream career, be it arts or science. MIET has been training and coaching students to land their dream education and become lecturers and professors for years. With our experience and expertise, we understand the efforts and work required to crack your dream exam, and help you prepare exactly for that. The SLET classes at MIET are just what you need to crack your dream career.
						</p><br/>
						<p>To suit your comfort and needs, MIET offers different modes and timings of batches so that students can learn and grow at their pace. </p>
                    </ScrollAnimation>	
                    <ScrollAnimation animateIn="fadeInRight">
                        <div className='blog-details-page-content'>
                            <blockquote>
                            <p><b>Mode of Classes </b>: Online, Offline & Hybrid</p>
                            <p><b>Classes </b>: Evening & Weekend Batches</p>
                            </blockquote>
                        </div>
					</ScrollAnimation>

                    <ScrollAnimation animateIn="fadeInRight">
						<h5 className="mb-0 mt-2">Exam Pattern</h5><br/>
						<p>SLET consists of two levels - Paper 1 & Paper 2. To prepare effectively for the exam, candidates should be familiar with Exam Patterns. 
						</p><br/>
						<table>
							<tr>
								<th>Paper</th>
								<th>Paper 1</th>
								<th>Paper 2</th>
							</tr>
							<tr>
								<td>Mode of Exam</td>
								<td>Offline</td>
								<td>Offline</td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
							<tr>
								<td>Duration of the Examination</td>
								<td>60 minutes</td>
								<td>120 minutes</td>
							</tr>
							<tr>
								<td>A Maximum number of questions</td>
								<td>50</td>
								<td>100</td>
							</tr>
                            <tr>
								<td>Type of Questions</td>
								<td>Objective-based</td>
								<td>Objective-based</td>
							</tr>
                            <tr>
								<td>Maximum number of marks</td>
								<td>100</td>
								<td>100</td>
							</tr>
                            <tr>
								<td>Marking Scheme</td>
								<td>2 mark each for the correct answer 0 mark for incorrect answer marked</td>
								<td>2 mark each for a correct answer 0 mark for incorrect answer marked</td>
							</tr>
                            <tr>
								<td>Language of Paper</td>
								<td>Hindi, Marathi, Urdu, Kannada, Telugu, English, Gujarati etc.</td>
								<td>Hindi, Marathi, Urdu, Kannada, Telugu, English, Gujarati etc.</td>
							</tr>
						</table><br/>
                    </ScrollAnimation>
               
                  <ScrollAnimation animateIn="fadeInRight">
					
                    <h5 className="mb-0 mt-2">SLET Paper 1 Syllabus 2022</h5>
                    <p>Paper 1 is compulsory for all candidates. Candidates are assessed primarily on their teaching and research capabilities. Candidates are expected to exhibit cognitive skills, such as comprehension, analysis, evaluation, knowledge of argument structure, as well as inductive and deductive reasoning. Candidates are also expected to have a general understanding of higher education.</p><br/>
                    <table>
							<tr>
								<th>Subject</th>
								<th>Syllabus</th>
							</tr>
							<tr>
								<td>Teaching Aptitude</td>
								<td>
                                    <ul>
                                        <li>Teaching: Nature, objectives, characteristics, and basic requirements;</li>
                                        <li>Learner’s characteristics;</li>
                                        <li>Factors affecting teaching;</li>
                                        <li>Methods of teaching;</li>
                                        <li>Teaching aids;</li>
                                        <li>Evaluation systems.</li>
                                    </ul>
                                </td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
							<tr>
                            <td>Research Aptitude</td>
								<td>
                                    <ul>
                                        <li>Research: Meaning, Types, and Characteristics, Positivism and Postpositivistic approach to research.</li>
                                        <li>Methods of Research: Experimental, Descriptive, Historical, Qualitative, and Quantitative methods.</li>
                                        <li>Steps of Research.</li>
                                        <li>Thesis and Article writing: Format and styles of referencing. Application of ICT in research.</li>
                                        <li>Research ethics.</li>
                                    </ul>
                                </td>
							</tr>
							<tr>
                            <td>Comprehension</td>
								<td>You will be given a passage of text. Questions are asked from the passage
                                </td>
							</tr>
                            <tr>
                            <td>Communication</td>
								<td>
                                    <ul>
                                        <li>Communication: Meaning, types, and characteristics of communication.</li>
                                        <li>Effective communication: Verbal and Non-verbal, Inter-Cultural and group communications, Classroom communication.</li>
                                        <li>Barriers to effective communication.</li>
                                        <li>Mass-Media and Society.</li>
                                    </ul>
                                </td>
							</tr>
                            <tr>
                            <td>Data Interpretation	</td>
								<td>
                                    <ul>
                                        <li>Sources, acquisition and interpretation of data</li>
                                        <li>Quantitative and qualitative data;</li>
                                        <li>Graphical representation and mapping of data.</li>
                                    </ul>
                                </td>
							</tr>
                            <tr>
                            <td>Information and Communication Technology (ICT)	</td>
								<td>
                                    <ul>
                                        <li>ICT: meaning, advantages, disadvantages and uses;</li>
                                        <li>General abbreviations and terminology;</li>
                                        <li>Basics of internet and e-mailing.</li>
                                    </ul>
                                </td>
							</tr>
                            <tr>
                            <td>People and Environment	</td>
								<td>
                                    <ul>
                                        <li>People and environment interaction;</li>
                                        <li>Sources of pollution;</li>
                                        <li>Pollutants and their impact on human life, exploitation of natural and energy resources;</li>
                                        <li>Natural hazards and mitigation</li>
                                    </ul>
                                </td>
							</tr>
                            <tr>
                            <td>Higher Education System: Governance, Polity And Administration		</td>
								<td>Structure of the institutions for higher learning and research in India; formal and distance education; professional/technical and general education; value education: governance, polity and administration; concept, institutions and their interactions.
                                </td>
							</tr>
						</table><br/>
                        </ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
				  
                    <h5 className="mb-0 mt-2">SLET Paper 2 Syllabus</h5>
                    <p>The below list shows various generic subjects common to all states.</p>
                    <ul>
                        <li>English</li>
                        <li>Economics</li>
                        <li>Political Science</li>
                        <li>Education</li>
                        <li>Commerce</li>
                        <li>Geography</li>
                        <li>History</li>
                        <li>Anthropology</li>
                        <li>Computer Science</li>
                        <li>Environmental Science</li>
                        <li>Hindi</li>
                        <li>Law</li>
                        <li>Life Science</li>
                        <li>Mathematical Sciences</li>
                        <li>Persian</li>
                        <li>Philosophy</li>
                        <li>Physical Science</li>
                        <li>Sanskrit</li>
                        <li>Sociology</li>
                    </ul>

                    
					
                    </ScrollAnimation>	
					
                    <ScrollAnimation animateIn="fadeInRight">
                        <div className='blog-details-page-content'>
                            <blockquote>
                            <h5 className="mb-0 mt-2">Qualifications:</h5>
                    <p>Candidates aspiring to become teachers upon the qualification of the SLET Examination should possess the following educational qualifications.</p><br/>
                    <table>
							<tr>
								<th>Required Marks in Master’s Degree:</th>
								<th>Other Educational Aspected</th>
							</tr>
							<tr>
								<td>
                                    <ul>
                                        <li>General: Minimum 55%</li>
                                        <li>OBC, SC, ST, PWD- at least 50% marks.</li>
                                    </ul>
                                </td>
								<td>
                                    <ul>
                                        <li>Candidates who are appearing (Final year) in their Master's Degree examination can also apply for SET.</li>
                                        <li>Those postgraduate students who have passed the postgraduate examination in more than one subject can appear for the SLET examination only in one subject at a time.</li>
                                    </ul>
                                </td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
							
						</table><br/>
                            </blockquote>
                        </div>
					</ScrollAnimation>
                  </div>
		      </div>
			  <Sidebar courseRestriction="SLET"/>
		    </div>
		  </div>
		</div>

        }
}

export default SLETDetails